export default function buildFormatLongFn (args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {}
    var width = options.width ? String(options.width) : args.defaultWidth
    var format = args.formats[width] || args.formats[args.defaultWidth]
    return format
  }
}



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
// module id = 674
// module chunks = 2 3 4 5 6 7 12 14